import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;

  .content {
    max-width: 690px;
    width: 100%;
    background-color: #ffffff;
    padding: 75px 20px 90px;
    border-radius: 4px;

    img {
      width: 90px;
    }

    h1 {
      font-size: 20px;
      margin-top: 20px;
    }

    p {
      max-width: 368px;
      margin: auto auto 22px;
    }

    button,
    a {
      padding: 14px 39px;
      margin: 0 10px;
    }
  }
`;
